const UNITS = ['B', 'kb', 'MB', 'GB', 'TB'] as const

/** Human-readable file size. Bytes show as integers; larger units show up to
 *  2 decimals with trailing zeros trimmed (e.g. 80 → "80 MB", 1.5 → "1.5 kb"). */
export const formatFileSize = (bytes: number): string => {
  if (bytes <= 0) return '0 B'
  const exponent = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    UNITS.length - 1,
  )
  const value = bytes / 1024 ** exponent
  const rounded = exponent === 0 ? value : parseFloat(value.toFixed(2))
  return `${rounded} ${UNITS[exponent]}`
}
